const GET_SHOP_REGIONS = "GET_SHOP_REGIONS";
const GET_SHOP_REGIONS_SUCCESS = "GET_SHOP_REGIONS_SUCCESS";
const GET_SHOP_REGIONS_FAILURE = "GET_SHOP_REGIONS_FAILURE";
const CLEAR_SHOP_REGIONS = "CLEAR_SHOP_REGIONS";

const GetShopRegionssSymbols = {
  GET_SHOP_REGIONS_SUCCESS,
  GET_SHOP_REGIONS_FAILURE,
  GET_SHOP_REGIONS,
  CLEAR_SHOP_REGIONS,
};

export default GetShopRegionssSymbols;
